<template>
  <div class="layout">
    <el-container>
      <el-header height="90px" class="hidden-sm-and-down">
        <Header />
      </el-header>
      <el-header height="80px" class="hidden-md-and-up">
        <MobileHeader />
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer height="auto" class="hidden-sm-and-down">
        <Footer />
      </el-footer>
      <el-footer height="auto" class="hidden-md-and-up">
        <MobileFooter />
      </el-footer>
    </el-container>
    <el-scrollbar>
      <el-backtop :bottom="100">
        <div>
          <i class="el-icon-caret-top"></i>
        </div>
      </el-backtop>
    </el-scrollbar>
    <service />
  </div>
</template>

<script>
import Header from "@/views/header/header";
import MobileHeader from "@/views/mobile/header/header";
import Footer from "@/views/Footer/footer";
import MobileFooter from "@/views/mobile/footer/footer";
import service from "@/views/service";
export default {
  name: "layout",
  components: { Header, Footer, MobileHeader, MobileFooter, service },
  data() {
    return {

    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang='scss'>
.layout {
  .el-header {
    position: fixed;
    top: 0;
    padding: 0;
    width: 100%;
    z-index: 1000;
    // background: #219167;
  }
  .el-footer {
    min-height: 3rem;
    background-color: $color_black;
    padding: 0;
    overflow-x: hidden;
    // color: #333;
    // text-align: center;
  }
  .el-main {
    margin-top: 80px;
    // background-color: #e9eef3;
    // color: #333;
    // text-align: center;
    overflow-x: hidden;
    min-height: calc(100vh - 80px);
    padding: 0 0 20px 0;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue